<template>
<b-container id="register-organization-container" class="register-organization-container" v-if="form != null && loaded">
	<div class="login-form-wrapper">

	<branding-heading></branding-heading>
<div v-show="submitted">
	<h1>Please Confirm Your Registration</h1>
	<p>We sent an message to <strong>{{form.email.value}}</strong>. Please click the confirmation link within the email.</p>

	<p><b-button @click="resendConfirmationEmail" class="mr-3 mb-3">Re-send Confirmation Email <b-spinner small label="Saving..." class="ml-2" v-if="saving" /></b-button> <b-button variant="light" @click="goBack" class="mb-3">Back to Login</b-button></p>

</div>
<b-form @submit="onSubmit" @reset="onReset" v-show="!submitted">
	<h1>Register Your Organization</h1>
	<b-row>
		<b-col>
			<b-form-group label="Organization Name"
				:state="form.name.status"
				:invalid-feedback="form.name.invalidMessage"
			>
			<b-form-input placeholder="" v-model="form.name.value"
				:state="form.name.status"
				@input="form.name.resetStatus()"
			></b-form-input>
			</b-form-group>
		</b-col>
	</b-row>
	<b-row>
		<b-col>
			<b-form-group v-if="false" label="Organization Domain Name"
				:state="form.name.status"
				:invalid-feedback="form.name.invalidMessage"
			>
			<b-input-group prepend="@">
				<b-form-input placeholder="mycompany" v-model="form.domain.value"></b-form-input>
			</b-input-group>
			</b-form-group>


			<b-form-group label="Organization Domain Name"
				@click="focusDomainField"
				:state="organizationPrefix.status"
				:invalid-feedback="organizationPrefix.invalidMessage"
				class="lc__domain"
			>
			<p>The Organization Domain Name is added to the end of organizations and is required to login into the system.  You can use the full name of your company, an abbreviated version or something memorable.<br/><br/>For example: user@<strong>abcconstruction</strong> or user@<strong>abcco</strong> or user@<strong>abc</strong></p>

				<div @click="focusDomainField" id="domain-editable-content" class="form-control">
					<span id="domain-prefix" class="non-editable">@</span>
					<span id="domain-postfix" class="editable" @keydown="handleLCKeypress" @focus="setFocusStyle" @blur="removeDomainFocus" @input="setNewDomain" contenteditable="true" v-html="organizationPrefix.value"></span>
				</div>
			</b-form-group>

		</b-col>
	</b-row>
	<b-row>
	<b-col>
	<b-form-group label="First Name"
		:state="form.firstName.status"
		:invalid-feedback="form.firstName.invalidMessage"
	>
	<b-form-input placeholder="First Name" v-model="form.firstName.value"
		:state="form.firstName.status"
		@input="form.firstName.resetStatus()"
	></b-form-input>
	</b-form-group>


	<b-form-group label="Last Name"
		:state="form.lastName.status"
		:invalid-feedback="form.lastName.invalidMessage"
	>
	<b-form-input placeholder="Last Name" v-model="form.lastName.value"
		:state="form.lastName.status"
		@input="form.lastName.resetStatus()"
	></b-form-input>
	</b-form-group>

	<b-form-group label="Title"
		:state="form.title.status"
		:invalid-feedback="form.title.invalidMessage"
	>
	<b-form-input placeholder="Title" v-model="form.title.value"
		:state="form.title.status"
		@input="form.title.resetStatus()"
	></b-form-input>
	</b-form-group>

	<b-form-group label="Email Address"
		:state="form.email.status"
		:invalid-feedback="form.email.invalidMessage"
	>
	<b-form-input type="email" placeholder="Email Address" v-model="form.email.value"
		:state="form.email.status"
		@input="form.email.resetStatus()"
	></b-form-input>
	</b-form-group>

	<b-form-group label="Primary Phone"
		:state="form.phone.status"
		:invalid-feedback="form.phone.invalidMessage"
	>
	<b-input id="newOrgPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onPhoneFocus" @blur="onPhoneBlur" v-model="form.phone.value" placeholder="1-###-###-####"/>
	</b-form-group>


	<b-form-group label="Alternate Phone"
		:state="form.altPhone.status"
		:invalid-feedback="form.altPhone.invalidMessage"
	>
	<b-input id="newOrgAltPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onAltPhoneFocus" @blur="onAltPhoneBlur" v-model="form.altPhone.value" placeholder="1-###-###-####"/>

	</b-form-group>

	</b-col>
</b-row>

<b-row>
	<b-col class="pb-3">
		<b-button variant="primary" type="button" @click="onSubmit">Register <b-spinner small label="Saving..." class="ml-2" v-if="saving" /></b-button>

		<b-button variant="light" class="ml-3" type="button" @click="goBack">Back</b-button>

	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>

</b-form>
</div>
</b-container>
</template>


<script>
import RegisterOrganization from '../../models/RegisterOrganization';
// import Autocomplete from '@trevoreyre/autocomplete-vue'
import BootstrapField from '../../utility/BootstrapField';
import ErrorHandler from '../../utility/ErrorHandler';
// import treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect'

import Format from '../../utility/Format';
import Vue from 'vue'
// import { mapGetters } from 'vuex';
// import { mapActions } from 'vuex';
// import { mapMutations } from 'vuex';
import BrandingHeading from '../../components/BrandingHeading';

export default {
  name: 'AddOrganization',
  docTitle: "Register Organization - Lane Closures",

  components: {
  	BrandingHeading
  },

  data() {
	return {
		Format,
		RegisterOrganization,
		form: null,
		organizations: [],
		// showUnsavedChangesModal:false,
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		showRequiredFieldModal: false,
		show: true,
		submitted: false,
		resendToken:null,
		editedDomain:"INITIAL__DATA",
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
		organizationPrefix:new BootstrapField({
					value: null}),
		saving: false
	}
	},
	mounted() {
		this.LoadData();
		this.$nextTick(() => {
					var maindiv = document.getElementById('register-organization-container');
					if (maindiv) {
							maindiv.scrollIntoView();
					}
		})
   },
	computed: {
		organizationSuffix: function() {
			if (this.form.domain.value) {
				if (this.form.domain.value) {
					return this.form.domain.value;
				}
			}

			return "mycompany";
		}
	},
	watch: {
	},
  methods: {
  	onPhoneFocus:function() {
  		if (this.form.phone.value == null || this.form.phone.value == "") {
  			setTimeout(function(){
  			      document.getElementById('newOrgPhone').value = "1-";
  			      document.getElementById('newOrgPhone').selectionStart = document.getElementById('newOrgPhone').value.length;
  			      document.getElementById('newOrgPhone').selectionEnd = document.getElementById('newOrgPhone').value.length;
  			    },1);  // call the function after 50ms
  		}
  	},
  	onPhoneBlur:function() {
  		if (this.form.phone.value == "1-" || document.getElementById('newOrgPhone').value == "1-") {
  			this.form.phone.value = null;
  			setTimeout(function(){
  			    document.getElementById('newOrgPhone').value = null;
  			},1);  // call the function after 50ms
  		}
  	},
  	onAltPhoneFocus:function() {
  		if (this.form.altPhone.value == null || this.form.altPhone.value == "") {
  				// this.form.altPhone.value = "1-";
  			setTimeout(function(){
  			      document.getElementById('newOrgAltPhone').value = "1-";
  			      document.getElementById('newOrgAltPhone').selectionStart = document.getElementById('newOrgAltPhone').value.length;
  			      document.getElementById('newOrgAltPhone').selectionEnd = document.getElementById('newOrgAltPhone').value.length;
  			    },1);  // call the function after 50ms

  		}
  	},
  	onAltPhoneBlur:function() {
  		if (this.form.altPhone.value == "1-" || document.getElementById('newOrgAltPhone').value == "1-") {
  			this.form.altPhone.value = null;
  			setTimeout(function(){
  			    document.getElementById('newOrgAltPhone').value = null;
  			},1);  // call the function after 50ms
  		}
  	},
  	handleLCKeypress: function(event) {
  		if (event.key == " " || event.key == 'PageUp' || event.key == 'PageDown') {
  			event.preventDefault();
  		}
  	},
  	setDomainValidateStyle() {
  		document.getElementById('domain-editable-content').classList.remove('is-invalid');
  		document.getElementsByClassName('lc__domain')[0].getElementsByClassName('invalid-feedback')[0].classList.remove('d-block');
  		if(this.form.domain.value == '') {
  			document.getElementById('domain-editable-content').classList.add('is-invalid');
  		}
  	},
  	focusDomainField(e) {
  		document.getElementById('domain-postfix').focus();
  	},
  	setFocusStyle() {
  		requestAnimationFrame(() => document.execCommand('selectAll'));
  		document.getElementById('domain-editable-content').classList.add('focus');
  	},
  	setNewDomain(e) {
  		this.editedDomain = e.target.innerText;
  		if (e.target.innerText == "" && e.target.innerHTML != "")  {
  			this.editedDomain = e.target.innerHTML;
  		}

  	},

  	removeDomainFocus() {
  		if(this.editedDomain != 'INITIAL__DATA') {
  			this.form.domain.value = "@"+this.editedDomain.trim();
  		} else {
  			if (this.form.domain.value != null) {
	  			this.editedDomain = this.form.domain.value.replace("@", "");
	  		} else {
	  				this.editedDomain = "";
	  		}
  		}
  		this.setDomainValidateStyle();
  		document.getElementById('domain-editable-content').classList.remove('focus');
  	},


	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},
	getFlatTree(option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

	getLevelClassName(level) {
		return "level-"+level;
	},

		goBack() {
			this.$router.push('/register')
		},
		onSubmit(evt) {
			evt.preventDefault()
			if (!this.validateFields()) {
				return false;
			}

			let that = this;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.SaveNew(that.form);
			});

		},
		onReset(evt) {
			evt.preventDefault()
			this.show = false
			this.$nextTick(() => {
			this.show = true
			})
		},


		resendConfirmationEmail() {
			this.saving = true;
			if (this.resendToken != null) {
				Vue.prototype.$http({
					method: 'get',
					url: `${this.$store.state.apiUrl}/resend-organization-request-confirm-email/?jwt=${this.resendToken}&r=${Math.round(Math.random() * Math.pow(10, 6))}`
				}).then(response => {
					this.saving = false;
					// Handle Success
				}).catch(error => {
					this.saveState = 'fail';
					this.isButtonDisabled = false;
					this.saving = false;
					if (error) {
						Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
						this.onSubmitPromiseDeferred.reject();
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},


		SaveNew(t) {
			// Saves a new organization
			this.saving = true;
			if (t instanceof RegisterOrganization) {
				let go = true;
				if (go) {
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/new-organization-request/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: t.getRawValue()
				}).then(response => {
					// Handle Success
					this.resendToken = response.data.resendToken;

					this.saveState = 'success';
					this.saving = false;
					this.submitted = true;
					this.submissionStatus = 'submission-success';
					this.SaveNewSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					this.saveState = 'fail';
					this.isButtonDisabled = false;
					this.saving = false;
					if (error.response ) {
						if (error.response.status == 400) {
							this.showErrors(error.response.data.fields);
						}
					}

					/*
					if (error) {
						console.log(error);
						Vue.prototype.$bus.$emit("error:network", {error:error,submitted:t.getRawValue()});
					this.onSubmitPromiseDeferred.reject();
					}
					*/
					this.onSubmitPromiseDeferred.reject();

				}).finally(() => {
					this.isButtonDisabled = false;
				});
				}
			}
		},
		SaveNewSuccess() {
			// this.form.SetErrors({});
		},

		validateFields() {

			let valid = this.form.validate();
			if (valid ) {
				return true;
			}
			return false;
		},


			LoadData(id = this.id) {
				this.loaded = true;
				this.form = new RegisterOrganization();
			},
	},
	// beforeRouteLeave(to, from, next) {
	// 	if (this.loaded && this.form.hasChanges()) {
	// 		if (this.overrideUnsavedChanges) {
	// 			next(true);
	// 		} else {
	// 			this.showUnsavedChangesModal = true;
	// 			this.modalOnSave = (function() {
	// 				this.onSubmit().then(() => {
	// 					next(true);
	// 				}).catch(() => {
	// 					next(false);
	// 				});
	// 			}).bind(this);

	// 			this.modalOnLeave = (function() {
	// 				this.showUnsavedChangesModal = false;
	// 				next(true);
	// 			}).bind(this);

	// 			next(false);
	// 		}
	// 	}
	// 	else {
	// 		next(true);
	// 	}
	// },

}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>